export const environment = {
    production: true,
    emailJsPublicKey: 'WlaT-1odohfddTp7U',
  };